export default {
  namespaced: true,
  state: {
    foodSelect: [],
    foodSelectFlag: false,
    blogSelect: [],
    blogSelectFlag: false,
    sicknessSelect: [],
    sicknessSelectFlag: false,
    foodUnitSelect: [],
    foodUnitSelectFlag: false,
    foodMealSelect: [],
    foodMealSelectFlag: false,
    couponSelect: [],
    couponSelectFlag: false,
    actionSelect: [],
    actionSelectFlag: false,
    foodCategorySelect: [],
    foodCategorySelectFlag: false,
    specialDietSelect: [],
    specialDietSelectFlag: false,
    activityCategorySelect: [],
    activityCategorySelectFlag: false,
    blogCategorySelect: [],
    blogCategorySelectFlag: false,

    faqCategorySelect: [],
    faqCategorySelectFlag: false,
    ScheduleMessages: [],
    ScheduleMessagesFlag: false,

    activityGroupSelect: [],
    activityGroupSelectFlag: false,
    activityPackageSelect: [],
    activityPackageSelectFlag: false,
    activityPackageCourseSelect: [],
    activityPackageCourseSelectFlag: false,
    activitySelect: [],
    activitySelectFlag: false,
    faqSelect: [],
    faqSelectFlag: false,
    dynamicSelect: [],
    dynamicSelectFlag: false,
    nutritionistSelect: [],
    nutritionistSelectFlag: false,
    segmentSelect: [],
    segmentSelectFlag: false,
    campaignSelect: [],
    campaignSelectFlag: false,
    channelSelect: [],
    channelSelectFlag: false,
    attributionSelect: [],
    attributionSelectFlag: false,
    muscleSelect: [],
    muscleSelectFlag: false,
    sicknessCategorySelect: [],
    sicknessCategorySelectFlag: false,
    bannerPositionSelect: [],
    bannerPositionSelectFlag: false,
    departmentSelect: [],
    departmentSelectFlag: false,
    dietDurationPriceSelect: [],
    dietDurationPriceFlag: false,
    listFilter: { },
    specialDietFoodListSelect: [],
    specialDietFoodListSelectFlag: false,
    recommendCategorySelect: [],
    recommendCategorySelectFlag: false,
    foodRecipesSelect: [],
    foodRecipesSelectFlag: false,

    segmentBasicTypesSelect: [],
    segmentBasicTypesSelectFlag: false,
    luckyWheelSelect: [],
    luckyWheelSelectFlag: false,

  },
  getters: {
  },
  mutations: {
    setFoodSelect: (state, payload) => {
      state.foodSelect = Object.freeze(payload)
    },
    setFoodSelectFlag: (state, payload) => {
      state.foodSelectFlag = payload
    },
    setSicknessSelect: (state, payload) => {
      state.sicknessSelect = Object.freeze(payload)
    },
    setSicknessSelectFlag: (state, payload) => {
      state.sicknessSelectFlag = payload
    },
    setFoodUnitSelect: (state, payload) => {
      state.foodUnitSelect = Object.freeze(payload)
    },
    setFoodUnitSelectFlag: (state, payload) => {
      state.foodUnitSelectFlag = payload
    },
    setFoodMealSelect: (state, payload) => {
      state.foodMealSelect = Object.freeze(payload)
    },
    setFoodMealSelectFlag: (state, payload) => {
      state.foodMealSelectFlag = payload
    },
    setCouponSelect: (state, payload) => {
      state.couponSelect = Object.freeze(payload)
    },
    setActionSelect: (state, payload) => {
      state.actionSelect = Object.freeze(payload)
    },
    setActionSelectFlag: (state, payload) => {
      state.actionSelectFlag = payload
    },
    setCouponSelectFlag: (state, payload) => {
      state.couponSelectFlag = payload
    },
    setFoodCategorySelect: (state, payload) => {
      state.foodCategorySelect = Object.freeze(payload)
    },
    setFoodCategorySelectFlag: (state, payload) => {
      state.foodCategorySelectFlag = payload
    },
    setActivityCategorySelect: (state, payload) => {
      state.activityCategorySelect = Object.freeze(payload)
    },
    setActivityCategorySelectFlag: (state, payload) => {
      state.activityCategorySelectFlag = payload
    },
    setBlogCategorySelect: (state, payload) => {
      state.blogCategorySelect = Object.freeze(payload)
    },
    setBlogCategorySelectFlag: (state, payload) => {
      state.blogCategorySelectFlag = payload
    },
    setFaqCategorySelect: (state, payload) => {
      state.faqCategorySelect = Object.freeze(payload)
    },

    setFaqCategorySelectFlag: (state, payload) => {
      state.faqCategorySelectFlag = payload
    },
     setScheduleMessages: (state, payload) => {
      state.ScheduleMessages = Object.freeze(payload)
    },

    setScheduleMessagesFlag: (state, payload) => {
      state.ScheduleMessagesFlag = payload
    },

    setActivityGroupSelect: (state, payload) => {
      state.activityGroupSelect = Object.freeze(payload)
    },
    setActivityGroupSelectFlag: (state, payload) => {
      state.activityGroupSelectFlag = payload
    },
    setActivityPackageSelect: (state, payload) => {
      state.activityPackageSelect = Object.freeze(payload)
    },
    setActivityPackageSelectFlag: (state, payload) => {
      state.activityPackageSelectFlag = payload
    },
    setActivityPackageCourseSelect: (state, payload) => {
      state.activityPackageCourseSelect = Object.freeze(payload)
    },
    setActivityPackageCourseSelectFlag: (state, payload) => {
      state.activityPackageCourseSelectFlag = payload
    },
    setActivitySelect: (state, payload) => {
      state.activitySelect = Object.freeze(payload)
    },
    setActivitySelectFlag: (state, payload) => {
      state.activitySelectFlag = payload
    },
     setFaqSelect: (state, payload) => {
      state.faqSelect = Object.freeze(payload)
    },
    setFaqSelectFlag: (state, payload) => {
      state.faqSelectFlag = payload
    },

    setLuckyWheelSelect: (state, payload) => {
      state.luckyWheelSelect = Object.freeze(payload)
    },
    setLuckyWheelSelectFlag: (state, payload) => {
      state.luckyWheelSelect = payload
    },
    setDynamicSelect: (state, payload) => {
      state.dynamicSelect = Object.freeze(payload)
    },
    setDynamicSelectFlag: (state, payload) => {
      state.dynamicSelectFlag = payload
    },
    setNutritionistSelect: (state, payload) => {
      state.nutritionistSelect = Object.freeze(payload)
    },
    setNutritionistSelectFlag: (state, payload) => {
      state.nutritionistSelectFlag = payload
    },
    setSegmentSelect: (state, payload) => {
      state.segmentSelect = Object.freeze(payload)
    },
    setSegmentSelectFlag: (state, payload) => {
      state.segmentSelectFlag = payload
    },
    setCampaignSelect: (state, payload) => {
      state.campaignSelect = Object.freeze(payload)
    },
    setCampaignSelectFlag: (state, payload) => {
      state.campaignSelectFlag = payload
    },
    setChannelSelect: (state, payload) => {
      state.channelSelect = Object.freeze(payload)
    },
    setChannelSelectFlag: (state, payload) => {
      state.channelSelectFlag = payload
    },
    setAttributionSelect: (state, payload) => {
      state.attributionSelect = Object.freeze(payload)
    },
    setAttributionSelectFlag: (state, payload) => {
      state.attributionSelectFlag = payload
    },
    setDepartmentSelect: (state, payload) => {
      state.departmentSelect = Object.freeze(payload)
    },
    setDepartmentSelectFlag: (state, payload) => {
      state.departmentSelectFlag = payload
    },
    setListFilter: (state, payload) => {
      state.listFilter[payload.key] = payload.value
    },
    setDietDurationPriceFlag: (state, payload) => {
      state.dietDurationPriceFlag = payload
    },
    setDietDurationPriceSelect: (state, payload) => {
      state.dietDurationPriceSelect = Object.freeze(payload)
    },
    setMuscleSelectFlag: (state, payload) => {
      state.muscleSelectFlag = payload
    },
    setMuscleSelect: (state, payload) => {
      state.muscleSelect = Object.freeze(payload)
    },
    setSicknessCategorySelectFlag: (state, payload) => {
      state.sicknessCategorySelectFlag = payload
    },
    setSicknessCategorySelect: (state, payload) => {
      state.SicknessCategorySelect = Object.freeze(payload)
    },
    setBannerPositionFlag: (state, payload) => {
      state.bannerPositionFlag = payload
    },
    setBannerPositionSelect: (state, payload) => {
      state.bannerPositionSelect = Object.freeze(payload)
    },
    setSpecialDietFoodListSelectFlag: (state, payload) => {
      state.specialDietFoodListSelectFlag = payload
    },
    setSpecialDietFoodListSelect: (state, payload) => {
      state.specialDietFoodListSelect = Object.freeze(payload)
    },
    setRecommendCategorySelectFlag: (state, payload) => {
      state.recommendCategorySelectFlag = payload
    },
    setRecommendCategorySelect: (state, payload) => {
      state.recommendCategorySelect = Object.freeze(payload)
    },
    setBlogSelectFlag: (state, payload) => {
      state.blogelectFlag = payload
    },
    setBlogSelect: (state, payload) => {
      state.blogSelect = Object.freeze(payload)
    },
    setFoodRecipesSelect: (state, payload) => {
      state.foodRecipesSelect = Object.freeze(payload)
    },
    setFoodRecipesSelectFlag: (state, payload) => {
      state.foodRecipesSelectFlag = payload
    },
    setSpecialDietSelect: (state, payload) => {
      state.specialDietSelect = Object.freeze(payload)
    },
    setSpecialDietSelectFlag: (state, payload) => {
      state.specialDietSelectFlag = payload
    },
    setSegmentBasicTypesSelect: (state, payload) => {
      state.segmentBasicTypesSelect = Object.freeze(payload)
    },
    setSegmentBasicTypesSelectFlag: (state, payload) => {
      state.segmentBasicTypesSelectFlag = payload
    },
  },
  actions: {},
}
